<template>
  <div class="page-index-content">
    <template v-for="(content, index) in contentList">
      <div class="content-item odd" v-if="index % 2 === 0">
        <div class="content-box">
          <div class="left-box img">
            <img :src="content.imgSrc"/>
          </div>
          <div class="right-box text color-blue">
            <!--<h2>{{content.title}}</h2>-->
            <template v-for="(subTitle, index) in content.title.split('\n')">
              <h2 :style="{'color': index === 0 ? '#2079FA' : '#212530'}">{{subTitle}}</h2>
            </template>
            <template v-for="(desc, index) in content.description.split('\n')">
              <p :class="'p'+ (index + 1)">{{desc}}</p>
            </template>
          </div>
        </div>
      </div>
      <div class="content-item even" v-else>
        <div class="content-box">
          <div class="left-box text">
            <!--<h2>{{content.title}}</h2>-->
            <template v-for="(subTitle, index) in content.title.split('\n')">
              <h2 :style="{'color': index === 0 ? '#2079FA' : '#212530'}">{{subTitle}}</h2>
            </template>
            <template v-for="(desc, index) in content.description.split('\n')">
              <p :class="'p'+ (index + 1)">{{desc}}</p>
            </template>
            <!--<div v-html="content.description.replace(/(\r\n)|(\n)/g, '<br/>')"></div>-->
          </div>
          <div class="right-box img">
            <img :src="content.imgSrc"/>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import AppService from '@/assets/service/App'
export default {
  name: 'Index',
  data () {
    return {
      contentList: []
    }
  },
  created () {
    this.getBannerList()
  },
  methods: {
    getBannerList (){
      AppService.getHomeContent().then((res) => {
        if (+res.code === 200){
          this.contentList = res.data
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .page-index-content {
    padding-bottom: 120px;
    width: 100%;
    .content-item {
      overflow: hidden;
      padding-top: 60px;
      height: 560px;
      .content-box {
        width: 1200px;
        margin: 0 auto;
      }
      .left-box, .right-box{
        display: inline-block;
        vertical-align: middle;
        box-sizing: border-box;
        &.text {
          width: 520px;
        }
        &.img {
          width: 680px;
          height: 560px;
          line-height: 560px;
          img{
            display: inline-block;
            width: 100%;
            /*height: 100%;*/
            vertical-align: middle;
          }
        }
        h2{
          font-size: 40px;
          color: #212530;
          line-height: 56px;
          font-weight: 600;
          span{
            color:rgba(32,121,250,1);
          }
        }
        p{
          &.first-desc{
            margin-top: 26px;
          }
          &.p1 {
            margin-top: 12px;
          }
          font-size: 16px;
          font-weight: 400;
          color: #212530;
          line-height: 32px;
        }
      }
      .left-box {
        &.text {
          padding-right: 60px;
        }
      }
      .right-box{
        &.text {
          padding-left: 80px;
        }
      }
    }
  }
</style>
